module.exports = __webpack_public_path__ + "static/img2-9dcba5beff6a7ea48cdf4cb50ff0a246.jpg";